export default "__VITE_ASSET__e50200c3__"